import { DiagnosticCode } from '../../../../DiagnosticCode';
import { DiagnosticMessage } from '../../../../DiagnosticMessage';
import { BuiltinMemberCall } from '../../BuiltinMemberCall';
export class Hash256From extends BuiltinMemberCall {
    emitCall(sb, _func, node, options) {
        const address = sb.context.analysis.extractLiteralHash256(node);
        if (address === undefined) {
            sb.context.reportError(node, DiagnosticCode.InvalidLiteral, DiagnosticMessage.InvalidHash256);
            return;
        }
        sb.emitPushBuffer(node, address);
        sb.emitHelper(node, options, sb.helpers.wrapBuffer);
    }
}

//# sourceMappingURL=from.js.map
